import { AddToCartRequestProductItem, PaxInfo, PaxType, ProductType } from '@cart-js/core';

interface ActivityAddToCartModel {
    activityId?: string;
    activityToken: string;
    travelDate: string;
    paxInfo: PaxInfo[];
}

export const paxTypeMapper = (code: string): PaxType => {
    const paxTypeMap: { [key: string]: PaxType } = {
        CHILD: PaxType.Child,
        INFANT: PaxType.Infant,
        ADULT: PaxType.Adult,
    };
    return paxTypeMap[code] || PaxType.Adult;
};

export const activityAddToCartMapper = (activityModel: ActivityAddToCartModel): AddToCartRequestProductItem => {
    const productItem: AddToCartRequestProductItem = {
        criteria: {
            productReqToken: activityModel.activityToken,
            productReqId: activityModel.activityId || '',
        },
        productInfo: {
            productType: ProductType.Activity,
            productId: '',
            productOfferId: '',
            supplierId: 0,
            subSupplierId: 0,
            paxInfo: activityModel.paxInfo,
            quantity: 1,
            startDate: activityModel.travelDate,
            endDate: activityModel.travelDate,
        },
    };
    return productItem;
};
